module.exports = __webpack_public_path__ + "static/media/integracao.1b2b676b.jpg";